import React, {FC, ReactNode} from 'react';
import {sx} from './sx'
import Box from '@mui/material/Box';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {classNames} from "@helpers/classNames";

interface IProps {
    children: ReactNode,
    isLoading?:boolean
}

const SidebarPanelContainerUi: FC<IProps> = ({children,isLoading}) => {
    return (
        <Box
            sx={sx.root}
            className={classNames(isLoading && 'isLoading')}
        >

            {isLoading && <SpinnerCustom/>}

            {children}
        </Box>
    );
};

export default SidebarPanelContainerUi;